import ImagePicker from './ImagePickerGroup';

export default ImagePicker;
